import React from 'react'
import Navbar from '../../components/ui/Navbar'
import Footer from '../../components/ui/Footer'
import Brand from "../../components/ui/Brand";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import { GoogleIcon } from "../../components/Icons";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useLocation } from "react-router-dom";

// import messages
import ErrorMessage from '../../components/ui/messagesandalerts/error'
import SuccessMessage from '../../components/ui/messagesandalerts/success'

function SignUp() {
  const navigate = useNavigate();
  const [error, setError] = React.useState("")
  const [successMessage, setSuccessMessage] = React.useState("")
  const [proccessing, setProccessing] = React.useState(false)

  // set form values
  const [email, setEmail] = React.useState("")
  const [fullname, setfullName] = React.useState("")
  const [countryofresidence, setCountryofresidence] = React.useState("")
  const [password, setPassword] = React.useState("")

  const ProcceedSignIn = ((e) => {
    e.preventDefault();

    setProccessing(true)
    axios.post('https://sea-turtle-app-vo8po.ondigitalocean.app/auth/signup',
      {
        email,
        fullname,
        countryofresidence,
        password
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    )
      .then(function (response) {
        setProccessing(true)
        // console.log(response.data.authToken);
        Cookies.remove('authToken')
        Cookies.remove('userfullname')
        Cookies.remove('useremail')
        Cookies.remove('userrole')
        Cookies.remove('userid')
        Cookies.remove('userverificationstatus')

        Cookies.set('authToken', response.data.authToken)
        Cookies.set('userfullname', response.data.userfullname)
        // console.log(response.data.userfullname)
        Cookies.set('useremail', response.data.useremail)
        Cookies.set('userrole', response.data.userrole)
        Cookies.set('userid', response.data.userid)
        Cookies.set('userverificationstatus', response.data.useremail)

        setError("")
        setSuccessMessage("Successfully signed up . Please wait .. Redirecting you now.")

        const timeOut = setTimeout(navigateFunction, 2000)

        function navigateFunction() {
          navigate("/account");
        }
      })
      .catch(function (error) {
        setProccessing(false)
        console.log(error.response.data.message);
        setSuccessMessage("")
        setError(error.response.data.message)
      });
  })

  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className='bg-gray-900'>
      <Navbar />
      <main className='w-full mt-12 authForms flex flex-col items-center justify-center px-4'>
        <div className='max-w-sm w-full text-gray-300'>
          <div className='text-center'>
            <Brand className='mx-auto w-32' />
            <div className='mt-5 space-y-2'>
              <h1 className='text-white text-2xl font-bold sm:text-3xl'>
                New account sign up
              </h1>
              <p className=''>
                Already have an account?{" "}
                <Link
                  to='/auth/signin'
                  className='font-medium text-purple-500 hover:text-purple-600 duration-150'>
                  Sign in now
                </Link>
              </p>
            </div>
          </div>

          <div className="messagesDiv mt-5">
            {
              error && <ErrorMessage message={error} />
            }

            {
              successMessage && <SuccessMessage message={successMessage} />
            }

          </div>

          <form onSubmit={ProcceedSignIn} className='mt-8 space-y-5'>
            <div>
              <label className='font-medium'>Email</label>
              <Input
                value={email}
                type='email'
                required
                onChange={(e) => setEmail(e.target.value)}
                className='w-full mt-2 text-gray-300 bg-gray-800 focus:bg-gray-900 focus:border-gray-800'
              />
            </div>
            <div>
              <label className='font-medium'>Full Name</label>
              <Input
                value={fullname}
                type='text'
                required
                onChange={(e) => setfullName(e.target.value)}
                className='w-full mt-2 text-gray-300 bg-gray-800 focus:bg-gray-900 focus:border-gray-800'
              />
            </div>
            <div>
              <label className='font-medium'>Country of residence</label>
              <Input
                value={countryofresidence}
                type='text'
                required
                onChange={(e) => setCountryofresidence(e.target.value)}
                className='w-full mt-2 text-gray-300 bg-gray-800 focus:bg-gray-900 focus:border-gray-800'
              />
            </div>
            <div>
              <label className='font-medium'>Password</label>
              <Input
                value={password}
                type='password'
                required
                className='w-full mt-2 text-gray-300 bg-gray-800 focus:bg-gray-900 focus:border-gray-800'
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {
              proccessing && <Button className='w-full text-gray-800 bg-gray-100 hover:bg-gray-200 
              ring-offset-2 focus:ring rounded-lg'>
                Signing you up. Please Wait ...
              </Button>
              ||
              <Button type="submit" className='w-full text-gray-800 bg-gray-100 hover:bg-gray-200 
              ring-offset-2 focus:ring rounded-lg'>
                Procceed Sign up
              </Button>
            }

            <button
              type='button'
              className='w-full flex items-center justify-center gap-x-3 py-2.5 border border-gray-800 rounded-lg text-sm font-medium bg-gray-800/40 hover:bg-gray-800 ring-purple-500 focus:ring duration-150'>
              <GoogleIcon />
              Continue with Google
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default SignUp